module.exports = __webpack_public_path__ + "images/logos/logo_mob@x2.017bf90f729a8094e42916d625ea5df4.png";